import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {UpdateRegistrationDocumentPage} from './update-registration-document';
import { IonicSelectableModule } from 'ionic-selectable';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  declarations: [
    UpdateRegistrationDocumentPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationDocumentPage),
    IonicSelectableModule,
    BrMaskerModule,
    FileUploadModule
  ],
  exports: [
    UpdateRegistrationDocumentPage
  ]
})
export class UpdateRegistrationDocumentPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/update-registration-document/update-registration-document.module.ts